import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getFormValues } from "redux-form"
import { fetchBasicData } from '../../actions/api'
import {
    getList,
    getListIsFetching,
    getModuleFetchError, getFiltersOpened
} from '../../selectors/index'
import SpinningDots from '../../../../components/Loader/SpinningDots'
import { getModule } from '../../selectors/index'
import ListFilterForm , {FILTER_FORM} from '../Filter/ListFilterForm'
import ChartContainer from '../../../../components/Graph/ChartContainer'
import '../List/List.css'
import {setFiltersOpened} from '../../actions'

class ConnectedGraph extends Component {
    renderListPanel() {
        const {
            isFetching,
            module,
            chartParams,
            filtersOpened,
            objects,
            formValues,
            setFiltersOpened,
            t
        } = this.props

        return (
            <div className="List-ListPanel">
                <ListFilterForm module={module} t={t} />
                {isFetching
                    ? <SpinningDots />
                    : (
                        <ChartContainer
                            objects={objects.byId}
                            allIds={objects.allIds}
                            setFiltersOpened={setFiltersOpened}
                            filtersOpened={filtersOpened}
                            formValues={formValues}
                            title={chartParams.title}
                            type={chartParams.type}
                            axis={chartParams.axis}
                            keys={chartParams.dataKeys}
                            format={chartParams.format}
                            aggregate={chartParams.aggregate}
                            filters={chartParams.filters}
                            yAxisUnit={chartParams.yAxisUnit}
                            colorRange={chartParams.colorRange}
                            t={t}
                        />
                    )
                }
            </div>
        )
    }

    renderError() {
        const { fetchError, clearErrors } = this.props

        return (
            <div>
                {fetchError}
                <button onClick={clearErrors}>Retry</button>
            </div>
        )
    }

    render() {
        const { fetchError } = this.props

        return fetchError ? this.renderError() : this.renderListPanel()
    }
}

const mapStateToProps = state => ({
    objects: getList(state),
    module: getModule(state),
    isFetching: getListIsFetching(state),
    fetchError: getModuleFetchError(state),
    filtersOpened: getFiltersOpened(state),
    formValues: getFormValues(FILTER_FORM)(state)
})

const mapDispatchToProps = dispatch => {
    return {
        clearErrors: fetchBasicData,
        setFiltersOpened: opened => dispatch(setFiltersOpened(opened))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedGraph)
